module.exports = __webpack_public_path__ + "static/media/classOnline.9f35c221.svg";